import React, {Component} from 'react'
import '../../components_style/PatientScreen.css'
import '../../components_style/rtl_css/PatientScreen.css'
import {doctorApi} from "../../services/ApiService";
import {
    deletePatient,
} from "../../redux/actions/Tabs-Actions";
import {connect} from "react-redux";
import {history} from "../../utils/history";
import SvGraphics from "../../assets/SvGraphics";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import PatientTreatmentPlans from "../../components/patient/PatientTreatmentPlans";
import TreatmentOverViewBlock from "../../components/patient/TreatmentOverViewBlock";
import {authenticationService} from "../../services/AuthenticationService";
import Patient_Page_Details from "../../components/patient/Patient_Page_Details";
import FormElementContainerExpandedPatientPage
    from "../../components/forms_builder/FormElementContainerExpandedPatientPage";
import Patient_Page_MedicalInfo from "../../components/patient/Patient_Page_MedicalInfo";
import Patient_Page_VisitHistory from "../../components/patient/Patient_Page_VisitHistory";
import Patient_Page_TreatmentResponse from "../../components/patient/Patient_Page_TreatmentResponse";
import Patient_Page_RequestHistory from "../../components/patient/Patient_Page_RequestHistory";
import ClinicEditForm from "../../components/clinic/ClinicEditForm";
import UploadedFilesForm from "../../components/patient/UploadedFilesForm";


class PatientConnected extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isStatusOpened: false,
            patientInfo: {},
            loading: true,
            changeInsurance: false,
            changeEmail: false,
            changePhone: false,
            newEmail: "",
            newInsurance: "",
            newPhone: "",
            profilePicUrl: null,
            hasNewVisit: false,
            showDemo: false,
            isSideBarOpen: false,
            statuses: [],
            filesArr: [],
            allRequests: [],
            Canabis_products: [],
            titrationPlans: [],
            lastTreatment: [],
            allData: {},
            isFromRequest: false,
            RequestID: ""
        }
    }

    checkHasNewVisit(lastRequest, lastRequestDate) {
        if (lastRequestDate) {
            let currentDate = new Date()
            currentDate = currentDate.toISOString().split('T')[0]
            lastRequestDate = lastRequestDate.split('T')[0]

            return currentDate !== lastRequestDate || lastRequest.IsRequest
        }
        return false
    }

    componentDidMount = async () => {
        let allData = await doctorApi.getAllData()
        let medical_diagnose_icd = []
        let israelCities = []
        let symptomsList = []
        let medicalConditions = []
        let allergics = []
        let statuses = []
        let medications = []
        let Canabis_products = []
        let titrationPlans = []
        if (allData) {
            allData = allData.data
            statuses = allData.statuses
            symptomsList = allData.symptoms
            medical_diagnose_icd = allData.medical_diagnose_icd
            israelCities = allData.cities
            medicalConditions = allData.medicalConditions
            allergics = allData.allergics
            medications = allData.medications
            titrationPlans = allData.titrationPlans
            Canabis_products = allData.products
        }

        this.setState({
            medical_diagnose_icd,
            Canabis_products,
            titrationPlans,
            israelCities,
            symptomsList,
            medications,
            allergics,
            medicalConditions,
            allData,
            statuses,
        })

        let patientInfo = this.props.location.state.rowInfo

        let isFromRequest = patientInfo.isFromRequest
        let RequestID = patientInfo.RequestID

        patientInfo = await doctorApi.getPatientById(patientInfo.UserStorageID)
        patientInfo = patientInfo ? patientInfo.data : ""
        let allRequests = patientInfo.Patient_requests ? patientInfo.Patient_requests : []
        let lastRequest = patientInfo.Patient_requests && patientInfo.Patient_requests.length > 0 ? patientInfo.Patient_requests[0] : {}
        let hasNewVisit = Object.keys(lastRequest).length > 0 ? this.checkHasNewVisit(lastRequest, lastRequest.requestDate) : true
        let loading = false

        let elmntToView = document.getElementById('asaya-info');
        if (elmntToView)
            elmntToView.scrollIntoView();

        let profilePic = await doctorApi.getProfilePic(patientInfo.UserStorageID)
        profilePic = profilePic ? profilePic.data.Form_url : null



        this.setState({
            profilePicUrl: profilePic,
            patientInfo, loading, hasNewVisit, allRequests,isFromRequest,
            RequestID
        })

    }


    onClickStatus = () => {
        this.setState({isStatusOpened: !this.state.isStatusOpened})
    }

    openPopUpChangeEmail() {
        this.setState({changeEmail: true})
    }

    openPopUpChangePhone() {
        this.setState({changePhone: true})
    }

    openPopUpChangeInsurance() {
        this.setState({changeInsurance: true})
    }

    goToAddRequestFromVisit = async () => {
        let {patientInfo} = this.state
        let response = await doctorApi.addRequestFromVisit(patientInfo.UserStorageID)
        if (response) {
            this.setState({hasNewVisit: true})
        }
    }

    goToPatientEdit = (patientInfo) => {
        let {allData, hasNewVisit} = this.state
        history.push({
            pathname: `/dashboard/PatientOnboard`,
            state: {
                patientInfo,
                allData,
                hasNewVisit,
                from: {
                    fromPath: `/dashboard`,
                }
            },
        })
    }


    onEmailChange(value) {

        this.setState({newEmail: value})
    }

    onInsuranceChange(value) {

        this.setState({newInsurance: value})
    }

    onPhoneChange(value) {
        if (value && !value.includes('972')) {
            value = "972" + value.substring(1)
        }
        this.setState({newPhone: value})
    }

    async saveNewEmail() {
        let patientID = this.state.patientInfo.PII?.UserStorageID
        await doctorApi.editPatientEmail({patientID: patientID, newEmail: this.state.newEmail})
        this.setState({changeEmail: false})
    }

    async saveNewInsurance() {
        let patientID = this.state.patientInfo.PII?.UserStorageID
        await doctorApi.editPatientInsurance({patientID: patientID, newInsurance: this.state.newInsurance})
        this.setState({changeInsurance: false})
    }

    async saveNewPhone() {
        let patientID = this.state.patientInfo.PII?.UserStorageID
        await doctorApi.editPatientPhone({patientID: patientID, newPhone: this.state.newPhone})
        this.setState({changePhone: false})
    }

    getPatientAge(birthday) {
        if (birthday !== null) {
            let todayDate = new Date().toISOString()
            let todayExactDate = (todayDate.split('T'))[0].split('-')
            let currentYear = todayExactDate[0]
            let currentMonth = todayExactDate[1]
            let birthDate = birthday ? birthday.toISOString() : ""
            let exactDate = (birthDate.split('T'))[0].split('-')
            let yearDiff = currentYear - exactDate[0]
            let monthDiff = currentMonth - exactDate[1]
            if (monthDiff < 0) {
                return (yearDiff - 1) + "." + (12 + monthDiff)
            } else {
                return yearDiff + "." + (monthDiff)
            }
        }
        return ""
    }

    async openSideBar() {
        let {patientInfo} = this.state
        let requests = patientInfo.Patient_requests ? patientInfo.Patient_requests : []
        let filesArr = []
        let language = localStorage.getItem('language')
        let fileDesc = language === "he" ? 'Form_desc_he' : 'Form_desc'
        for (let i = 0; i < requests.length; i++) {
            let requestsID = requests[i].RequestID
            if ((requests[i].IsVisit && !requests[i].IsRequest)
                || (requests[i].Clinic_ID && requests[i].clinic && requests[i].Clinic_ID === requests[i].clinic.Clinic_ID)) {
                let addedFilesList = await doctorApi.getAllUploadedFiles(requests[i].UserStorageID, requestsID)
                let addedFilesArr = addedFilesList ? addedFilesList.data : []
                addedFilesArr.map(item => {
                    let date = item.createdAt
                    if (date) {
                        date = date.split('T')[0].split('-').reverse().join('/')
                    }
                    filesArr.push(
                        <div className={"uploadedFileEntry"} key={item.Form_url}>
                            <SvGraphics svgname={'pdf-icon-black'}
                                        onClick={() => window.open(item.Form_url, '_blank')}
                                        style={{height: '20px', width: '15px', cursor: 'pointer'}}/>
                            <label className={"uploadedFileDesc"}>{item.Form_type[fileDesc]}</label>
                            <label className={"uploadedFileDate"}>{date}</label>
                        </div>)
                })

            }

        }
        this.setState({filesArr, isSideBarOpen: true})

        document.body.style.overflow = "hidden"
    }

    closeSideBar() {
        document.body.style.overflow = "hidden"
        this.setState({isSideBarOpen: false})
    }

    goBackToRequest = () => {
        let {RequestID,patientInfo}= this.state
        let rowInfo={RequestID:RequestID,UserStorageID:patientInfo.UserStorageID}
        history.push({
            pathname: `/pain_patientRequest`,
            state: {
                rowInfo,
                completed: false,
                from: {
                    fromPath: `/pain_requests_dashboard`,
                }
            },
        })
    }

    render() {
        let {
            medical_diagnose_icd,
            israelCities,
            symptomsList,
            allergics,
            medications,
            allRequests,
            titrationPlans,
            Canabis_products,
            medicalConditions,
            patientInfo,
            profilePicUrl,
            hasNewVisit,
            showDemo,
            isSideBarOpen,
            filesArr,
            isFromRequest
        } = this.state


        let currentUser = authenticationService.currentUserValue;
        let leumitUser = currentUser?.profile?.Leumit_clinic
        let id = ""
        let PatientName = ""
        let age = ""
        if (patientInfo && patientInfo.PII) {
            id = patientInfo.PII.ID_passport ? patientInfo.PII.ID_passport : ""
            PatientName = patientInfo.PII.First_name ? patientInfo.PII.First_name + " " + patientInfo.PII.Last_name : ""
            age = patientInfo.PII.Date_of_birth ? this.getPatientAge(new Date(patientInfo.PII.Date_of_birth)) : ""
        }


        let {t} = this.props

        if (this.state.loading) {
            return <div className="loader"/>
        }

        let gender = patientInfo.PII.Gender
        let language = localStorage.getItem('language')

        if (language === "he") {
            gender = gender === "Female" ? "נקבה" : gender
            gender = gender === "Male" ? "זכר" : gender
            gender = gender === "Specified" ? "לא ידוע" : gender
        }

        patientInfo['hasNewVisit'] = hasNewVisit
        patientInfo['profilePicUrl'] = profilePicUrl

        let patientLastRequest = patientInfo.Patient_requests ? patientInfo.Patient_requests[0] : {}

        let visitText = hasNewVisit ? t('patientPage.addNewVisit') : t('patientPage.EditVisit')


        return (
            <div>
                <div className={'asaya-info-selfOnboarding-sticky'} style={{display: 'flex'}}>
                    <img className={'profilePicPatientPage'} alt={""}
                         src={profilePicUrl} width={'100px'} height={'100px'}/>
                    <div className={'adminMargin-patientPage-title'}>
                        <div style={{display: 'flex', width: '65%'}}>
                            <label className="NewLeumitPatientTitle3">{PatientName}</label>
                            <div>
                                <label className="NewLeumitPatientTitle">{t('patient_boarding.id_number')}</label>
                                <label className="NewLeumitPatientTitleValue">{id}</label>
                            </div>
                            <div className={"title_splash"}/>
                            <div>
                                <label className="NewLeumitPatientTitle">{t('patient_boarding.age')}</label>
                                <label className="NewLeumitPatientTitleValue">{age}</label>
                            </div>
                            <div className={"title_splash"}/>
                            <div>
                                <label className="NewLeumitPatientTitle">{t('patientPage.Gender')}</label>
                                <label className="NewLeumitPatientTitleValue">{gender}</label>
                            </div>
                            <div className={"title_splash"}/>

                            <div className="NewLeumitPatientBlock">
                                <label className="NewLeumitPatientTitle">{t('patient_boarding.mediator')}</label>
                                <label className="NewLeumitPatientTitleValue">{patientInfo.MediatorCode}</label>
                            </div>

                        </div>

                        {isFromRequest && <div className={'Patient-Screen-block-title-button'}>
                            <div className={'Patient-Screen-block-label'}
                                 onClick={() => this.goBackToRequest()}> {t('patientPage.backToRequest')}</div>
                        </div>
                        }

                        {leumitUser !== "T" && <div className={'Patient-Screen-block-title-button'}>
                            <div className={'Patient-Screen-block-label'}
                                 onClick={() => this.goToPatientEdit(patientInfo)}>+ {visitText}</div>
                        </div>
                        }


                        {leumitUser !== "T" && !hasNewVisit && <div className={'Patient-Screen-block-title-button'}>
                            <div className={'Patient-Screen-block-label'}
                                 onClick={() => this.goToAddRequestFromVisit()}>{t('patientPage.sendRequest')}
                            </div>
                        </div>}

                        {/*    <div className={'Patient-Screen-block-title-button2'}>
                            <div className={'Patient-Screen-block-label'}>+ {t('patientPage.addQuickReport')}</div>
                        </div>*/}
                    </div>
                </div>


                <div className={'Patient-Screen'}>

                    <div className={'Patient-Screen-block'}>
                        <div className={'Patient-Screen-block-body-title'}>
                            <label className={'Patient-Screen-block-body-title-label'}>
                                {t('patientPage.patientDetails')}
                            </label>
                        </div>
                        <div className={'Patient-Screen-block'}>
                            {leumitUser !== "T" &&
                            <SvGraphics svgname={'pencil'} style={{height: '15px', width: '15px', margin: '7px 7px'}}/>}

                            {leumitUser !== "T" && <div className={'Patient-Screen-body-button'}
                                                        onClick={() => this.goToPatientEdit(this.state.patientInfo)}>{t('patientPage.editPatient')}</div>
                            }
                        </div>
                    </div>
                    <div>
                        {leumitUser === "T" && <div style={{display: 'flex', width: '31%', height: '60px'}}>
                            <div className={'Patient-Screen-body-button-changeEmail'}
                                 onClick={() => this.openPopUpChangeEmail()}
                            >{t('patientPage.changeEmail')}</div>
                            {this.state.changeEmail &&
                            <input className={'inputBoxStyle'} type="email" name="Email"
                                   defaultValue={this.state.newEmail}
                                   maxLength={50}
                                   onChange={(event) => this.onEmailChange(event.target.value)}/>
                            }
                            {this.state.changeEmail &&
                            <div className={'Patient-Screen-body-changeInfo-Button'}
                                 onClick={() => this.saveNewEmail()}>
                                {t('patient_boarding.save')}
                            </div>
                            }
                            {this.state.changeEmail &&
                            <div className={'Patient-Screen-body-changeInfo-Button'}
                                 onClick={() => this.setState({changeEmail: false})}>
                                {t('patient_boarding.close')}
                            </div>
                            }
                        </div>}
                        {leumitUser === "T" && <div style={{display: 'flex', width: '31%', height: '60px'}}>
                            <div className={'Patient-Screen-body-button-changeEmail'}
                                 onClick={() => this.openPopUpChangePhone()}
                            >{t('patientPage.changePhone')}</div>
                            {this.state.changePhone &&
                            <input className={'inputBoxStyle'} type="email" name="Email"
                                   defaultValue={this.state.newPhone}
                                   maxLength={20}
                                   onChange={(event) => this.onPhoneChange(event.target.value)}/>
                            }
                            {this.state.changePhone &&
                            <div className={'Patient-Screen-body-changeInfo-Button'}
                                 onClick={() => this.saveNewPhone()}>
                                {t('patient_boarding.save')}
                            </div>
                            }
                            {this.state.changePhone &&
                            <div className={'Patient-Screen-body-changeInfo-Button'}
                                 onClick={() => this.setState({changePhone: false})}>
                                {t('patient_boarding.close')}
                            </div>
                            }
                        </div>}

                        {leumitUser === "T" && <div style={{display: 'flex', width: '31%', height: '60px'}}>
                            <div className={'Patient-Screen-body-button-changeEmail'}
                                 onClick={() => this.openPopUpChangeInsurance()}
                            >{t('patientPage.changeInsurance')}</div>
                            {this.state.changeInsurance &&
                            <select className={'selectBoxRegistration'} id="InsuranceType" name="InsuranceType"
                                    onChange={(event) => this.onInsuranceChange(event.target.value)}>
                                <option value="" disabled selected>{t('patient_self_boarding.Insurance')}</option>
                                <option value={"1"}>{t('patient_self_boarding.Maccabi')}</option>
                                <option value={"2"}>{t('patient_self_boarding.Clalit')}</option>
                                <option value={"3"}>{t('patient_self_boarding.Leumit')}</option>
                                <option value={"4"}>{t('patient_self_boarding.Meuhedet')}</option>
                                <option value={"5"}>{t('patient_self_boarding.InsuranceCompany')}</option>
                                <option value={"6"}>{t('patient_self_boarding.IDF')}</option>
                                <option value={"7"}>{t('patient_self_boarding.MinistryOfDefence')}</option>
                                <option value={"8"}>{t('patient_self_boarding.None')}</option>
                                <option value={"9"}>{t('patient_self_boarding.PalestinianAuthority')}</option>
                                <option value={"10"}>{t('patient_self_boarding.other')}</option>
                            </select>
                            }
                            {this.state.changeInsurance &&
                            <div className={'Patient-Screen-body-changeInfo-Button'}
                                 onClick={() => this.saveNewInsurance()}>
                                {t('patient_boarding.save')}
                            </div>
                            }
                            {this.state.changeInsurance &&
                            <div className={'Patient-Screen-body-changeInfo-Button'}
                                 onClick={() => this.setState({changeInsurance: false})}>
                                {t('patient_boarding.close')}
                            </div>
                            }
                        </div>}
                    </div>


                    <div style={{margin: '20px 70px'}}>
                        <input style={{width: '10px', height: '10px'}} type={"checkbox"}
                               className={"checkboxStyle-treatment-symptoms"}
                               onClick={() => this.setState({showDemo: !showDemo})} defaultChecked={showDemo}
                        />
                        הצג נתוני דימו
                    </div>

                    <FormElementContainerExpandedPatientPage title={t('patientPage.contact_info')}
                                                             svgName={'pencil'}
                                                             isExpanded={true}
                                                             subTitle={''}
                                                             Component={Patient_Page_Details}
                                                             rest={{
                                                                 showDemo: showDemo,
                                                                 israelCities: israelCities,
                                                                 patientInfo: patientInfo,
                                                                 t: (e) => this.props.t(e),
                                                             }}/>
                    <FormElementContainerExpandedPatientPage title={t('patientPage.med_info')}
                                                             svgName={'paper_clip'}
                                                             isExpanded={true}
                                                             subTitle={t('patientPage.allDocs')}
                                                             Component={Patient_Page_MedicalInfo}
                                                             openSideBar={() => this.openSideBar()}
                                                             rest={{
                                                                 patientInfo: patientInfo,
                                                                 showDemo: showDemo,
                                                                 allergics: allergics,
                                                                 medications: medications,
                                                                 medicalConditions: medicalConditions,
                                                                 medical_diagnose_icd: medical_diagnose_icd,
                                                                 symptomsList: symptomsList,
                                                                 patientLastRequest: patientLastRequest,
                                                                 t: (e) => this.props.t(e),
                                                             }}/>
                    <FormElementContainerExpandedPatientPage title={t('patientPage.Visit_History')}
                                                             svgName={''}
                                                             subTitle={''}
                                                             isExpanded={false}
                                                             Component={Patient_Page_VisitHistory}
                                                             rest={{
                                                                 showDemo: showDemo,
                                                                 patientInfo: patientInfo,
                                                                 t: (e) => this.props.t(e),
                                                             }}/>
                    <FormElementContainerExpandedPatientPage title={t('patientPage.Request_History')}
                                                             svgName={''}
                                                             subTitle={''}
                                                             isExpanded={false}
                                                             Component={Patient_Page_RequestHistory}
                                                             rest={{
                                                                 showDemo: showDemo,
                                                                 statuses: this.state.statuses,
                                                                 patientInfo: patientInfo,
                                                                 t: (e) => this.props.t(e),
                                                             }}/>
                    {showDemo && <FormElementContainerExpandedPatientPage title={t('patientPage.treatmentResponse')}
                                                                          svgName={''}
                                                                          subTitle={''}
                                                                          isExpanded={false}
                                                                          Component={Patient_Page_TreatmentResponse}
                                                                          rest={{
                                                                              showDemo: showDemo,
                                                                              t: (e) => this.props.t(e),
                                                                          }}/>}


                    <div className={'Patient-Screen-block'}>
                        <div className={'Patient-Screen-block-body-title'}>
                            <label className={'Patient-Screen-block-body-title-label'}>
                                {t('patientPage.Treatment_Plan')}
                            </label>
                        </div>
                        <div style={{display: 'flex', margin: '30px 20px'}}>
                            <SvGraphics svgname={'history-icon'}
                                        style={{height: '20px', width: '20px', margin: '5px 5px'}}/>
                            <div className={'Patient-Screen-body-button'}>History</div>
                        </div>
                        <div style={{display: 'flex', margin: '30px 20px'}}>
                            <SvGraphics svgname={'pencil'} style={{height: '20px', width: '20px', margin: '5px 5px'}}/>
                            <div className={'Patient-Screen-body-button'}>{t('patientPage.Edit_Plan')}</div>
                        </div>

                    </div>

                    <PatientTreatmentPlans
                        showDemo={showDemo}
                        allRequests={allRequests}
                        titrationPlans={titrationPlans}
                        leumitUser={leumitUser}
                        Canabis_products={Canabis_products}
                    />


                    {showDemo && <div className={'Patient-Screen-block'}>
                        <div className={'Patient-Screen-block-body-title'}>
                            <label className={'Patient-Screen-block-body-title-label'}>
                                {t('patientPage.Treatment_Overview')}
                            </label>
                        </div>
                        <div className={'Patient-Screen-block'}>
                            <div className={'Patient-Screen-body-button'}
                                 style={{margin: '0 50px'}}>{t('patientPage.Last_Months')}</div>
                        </div>


                    </div>}
                    <div style={{height: '30px'}}/>

                    {showDemo && <TreatmentOverViewBlock
                        showDemo={showDemo}
                    />}


                    {isSideBarOpen && <UploadedFilesForm
                        t={e => t(e)}
                        filesArr={filesArr}
                        patientInfo={patientInfo}
                        isSideBarOpen={isSideBarOpen}
                        closeSideBar={() => this.closeSideBar()}
                    />}

                </div>
            </div>

        )
    }
}


function mapDispatchToProps(dispatch) {
    return {
        deletePatient: patientID => dispatch(deletePatient(patientID)),
    };
}

const mapStateToProps = () => {
    return {};
};
const Patient = compose(
    withTranslation(),
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(PatientConnected);

export default Patient;
